import React, { useState, useEffect, useRef } from "react";
//import "./Profile.css";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import dummyProfileImage from "../../../assets/dummy-profile-pic.png";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import imageCompression from "browser-image-compression";
import dayjs from "dayjs";
import {
  companyOptions,
  companyFilterOption,
  countryOptions,
  degreeOptions,
  designationOptions,
  domainOptions,
  languageOptions,
  skillsOptions,
  stateOptions,
} from "../../../Data/SelectOptions";
import CodeQueueSpinner, { handleError, handleSuccess } from "../../../Utils";
import { getEmail } from "../../../DecodeToken/DecodeToken";
import {
  getOneMentorDetails,
  updateMentorProfileDetails,
} from "../../../ApiServices/ApiServices";
import CreatableSelect from "react-select/creatable";

const experienceOptions = Array.from({ length: 31 }, (_, i) => ({
  value: `${i}+ ${i === 1 ? "Year" : "Years"}`,
  label: `${i}+ ${i === 1 ? "Year" : "Years"}`,
}));

const Profile = ({ isVisible, setIsVisible, fetchProgressStatus }) => {
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [selectedDegree, setSelectedDegree] = useState(null);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [profileImage, setProfileImage] = useState({
    url: "",
    filename: "",
    contentType: "",
    size: 0,
  });
  const [passingYear, setPassingYear] = useState(null);
  const [name, setName] = useState("");
  const [about, setAbout] = useState("");
  const [heading, setHeading] = useState("");
  const [college, setCollege] = useState("");
  const [loading, setLoading] = useState(true);
  const [otherCompany, setOtherCompany] = useState("");
  const [otherLang, setOtherLang] = useState("");
  const [otherDesignation, setOtherDesignation] = useState("");

  const email = getEmail();
  const calledOnce = useRef(false);
  useEffect(() => {
    if (calledOnce.current) return; // Exit if already called
    calledOnce.current = true;
    const mentorProfileDetails = async () => {
      try {
        const response = await getOneMentorDetails(email);
        setName(response.name);
        setHeading(response.heading);
        setSelectedDomain({
          label: response.selectedDomain,
          value: response.selectedDomain,
        });
        setAbout(response.about);
        setSelectedCountry({
          label: response.selectedCountry,
          value: response.selectedCountry,
        });
        setSelectedState({
          label: response.selectedState,
          value: response.selectedState,
        });
        setSelectedLanguage({
          label: response.selectedLanguage,
          value: response.selectedLanguage,
        });
        setSelectedCompany({
          label: response.currentCompany,
          value: response.currentCompany,
        });
        setSelectedDesignation({
          label: response.selectedDesignation,
          value: response.selectedDesignation,
        });
        // Map the skills array to the structure expected by the Select component
        const mappedSkills = response?.selectedSkills?.map((skill) => ({
          label: skill,
          value: skill,
        }));
        setSelectedSkills(mappedSkills);
        setSelectedExperience({
          label: response.selectedExperience,
          value: response.selectedExperience,
        });
        setCollege(response.college);
        setSelectedDegree({
          label: response.selectedDegree,
          value: response.selectedDegree,
        });
        setPassingYear(dayjs(response.passingYear));
        // Set the profileImage object
        if (response.profileImage) {
          setProfileImage({
            url: response.profileImage.url,
            filename: response.profileImage.filename,
            contentType: response.profileImage.contentType,
            size: response.profileImage.size,
          });
        }
      } catch (error) {
        return handleError(error?.response?.data.message);
      } finally {
        setLoading(false);
      }
    };

    mentorProfileDetails();
  }, []);

  const closePopup = () => {
    setIsVisible(!isVisible);
  };

  const handleAboutChange = (event) => {
    if (event.target.value.length <= 750) {
      setAbout(event.target.value);
    }
  };
  const handleHeadingChange = (event) => {
    if (event.target.value.length <= 250) {
      setHeading(event.target.value);
    }
  };
  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    setSelectedState(null);
  };
  const handleCollegeChange = (event) => {
    if (event.target.value.length <= 100) {
      setCollege(event.target.value);
    }
  };

  const handleSubmit = async () => {
    // Check if a new profileImage is being uploaded and if its size is valid
    if (profileImage && profileImage.size && profileImage.size > 200 * 1024) {
      return handleError("Image size should be less than 200kb.");
    }
    // Check if any fields are missing
    if (
      !name ||
      !about ||
      !heading ||
      !college ||
      !selectedDomain ||
      !selectedCountry ||
      !selectedState ||
      !selectedLanguage ||
      !selectedCompany ||
      !selectedDesignation ||
      selectedSkills.length === 0 ||
      !selectedDegree ||
      !passingYear
    ) {
      return handleError("All Fields are required");
    } else if (!profileImage.url) {
      return handleError("Please upload profile image");
    } else {
      try {
        const res = await updateMentorProfileDetails(
          email,
          profileImage,
          name,
          about,
          heading,
          college,
          selectedDomain.value,
          selectedCountry.value,
          selectedState.value,
          selectedLanguage.value === "Other"
            ? otherLang
            : selectedLanguage.value,
          selectedCompany.value === "Other"
            ? otherCompany
            : selectedCompany.value,
          selectedDesignation.value === "Other"
            ? otherDesignation
            : selectedDesignation.value,
          selectedSkills?.map((skill) => skill.value),
          selectedExperience.value,
          selectedDegree.value,
          passingYear
        );
        handleSuccess(res.message);
        setIsVisible(false);
        localStorage.setItem("loggedInUser", name);
        fetchProgressStatus();
      } catch (error) {
        return handleError(error?.response?.data?.message);
      }
    }
  };

  // Crop image to center square
  function cropToSquare(file) {
    return new Promise((resolve, reject) => {
      const img = new window.Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        img.src = e.target.result;
      };
      img.onload = () => {
        const size = Math.min(img.width, img.height);
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(
          img,
          (img.width - size) / 2,
          (img.height - size) / 2,
          size,
          size,
          0,
          0,
          size,
          size
        );
        canvas.toBlob((blob) => {
          if (blob) {
            const croppedFile = new File([blob], file.name, { type: file.type });
            resolve(croppedFile);
          } else {
            reject(new Error("Failed to crop image"));
          }
        }, file.type);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      // Crop to square first
      const croppedFile = await cropToSquare(file);

      // Compress image to below 200kb
      const options = {
        maxSizeMB: 0.2, // 200kb
        maxWidthOrHeight: 512,
        useWebWorker: true,
      };
      const compressedFile = await imageCompression(croppedFile, options);
      const base64 = await convertToBase64(compressedFile);

      setProfileImage({
        url: base64,
        filename: compressedFile.name,
        contentType: compressedFile.type,
        size: compressedFile.size,
      });
    } catch (err) {
      handleError("Failed to crop/compress image. Please try another image.");
    }
  };

  return (
    <>
      {isVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg text-center w-[500px] p-6 mt-[59px]">
            <div className="flex h-[400px]">
              {/* Sidebar */}
              <aside className="flex-col gap-5 pr-4 text-xs font-semibold text-gray-600">
                <div className="flex flex-col gap-2">
                  <span className="text-black font-normal">
                    <AccountCircleIcon />
                  </span>
                  <span>Profile</span>
                </div>
              </aside>

              <div className="h-full w-[0.5px] bg-gray-300"></div>

              {/* Main Content */}
              <main className="flex-1 pl-4">
                <div className="text-start text-lg font-semibold text-gray-800">
                  Profile
                </div>
                <div className="w-full h-[0.5px] bg-gray-300 my-2"></div>
                {loading ? (
                  <div className="flex justify-center items-center h-full">
                    <CodeQueueSpinner />
                  </div>
                ) : (
                  <div
                    className="overflow-y-auto max-h-[350px]"
                    style={{
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    {/* Profile Picture Section */}
                    <div className="flex flex-col items-start mt-8 mb-12">
                      <div className="bg-gradient-to-r from-blue-800 via-blue-600 to-blue-900 h-24 rounded-t-lg w-full relative">
                        <label
                          htmlFor="file-upload"
                          className="absolute top-8 left-8 cursor-pointer"
                        >
                          <img
                            src={profileImage.url || dummyProfileImage}
                            alt=""
                            loading="lazy"
                            decoding="async"
                            className="w-24 h-24 rounded-lg"
                          />
                        </label>
                        <input
                          type="file"
                          id="file-upload"
                          className="hidden"
                          accept=".jpeg, .png, .jpg"
                          onChange={(e) => handleFileUpload(e)}
                        />
                      </div>
                    </div>

                    {/* Name Section */}
                    <div className="text-start mb-4">
                      <label className="text-sm font-semibold text-gray-700">
                        Full Name <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    {/* Heading Section */}
                    <div className="text-start mb-4">
                      <label className="text-sm font-semibold text-gray-700 flex justify-between">
                        <span>
                          Profile Heading{" "}
                          <span className="text-red-500">*</span>
                        </span>
                        <span>{heading ? heading.length : 0}/250</span>
                      </label>
                      <input
                        type="text"
                        value={heading}
                        onChange={handleHeadingChange}
                        className="w-full border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    {/* About Section */}
                    <div className="text-start mb-4">
                      <label className="text-sm font-semibold text-gray-700 flex justify-between">
                        <span>
                          About <span className="text-red-500">*</span>
                        </span>
                        <span>{about ? about.length : 0}/750</span>
                      </label>
                      <textarea
                        value={about}
                        onChange={handleAboutChange}
                        className="w-full min-h-[80px] border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500"
                      ></textarea>
                    </div>

                    {/* Location Section */}
                    <div className="text-start mb-4">
                      <label className="text-sm font-semibold text-gray-700">
                        Location <span className="text-red-500">*</span>
                      </label>
                      <div className="flex gap-4">
                        <Select
                          options={countryOptions}
                          isSearchable
                          value={selectedCountry}
                          isClearable
                          placeholder="Country"
                          onChange={handleCountryChange}
                          className="w-full"
                          menuPortalTarget={document.body} // portal to body
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }), // high z-index
                          }}
                        />
                        <Select
                          options={stateOptions}
                          isSearchable
                          value={selectedState}
                          isClearable
                          isDisabled={!selectedCountry}
                          placeholder="State"
                          onChange={(selectedOption) =>
                            setSelectedState(selectedOption)
                          }
                          className="w-full"
                          menuPortalTarget={document.body} // portal to body
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }), // high z-index
                          }}
                        />
                      </div>
                    </div>

                    {/* Native Language Section */}
                    <div className="text-start mb-4">
                      <label className="text-sm font-semibold text-gray-700">
                        Native Language <span className="text-red-500">*</span>
                      </label>
                      <Select
                        options={languageOptions}
                        isSearchable
                        value={selectedLanguage}
                        isClearable
                        onChange={(selectedOption) =>
                          setSelectedLanguage(selectedOption)
                        }
                        className="w-full"
                        menuPortalTarget={document.body} // portal to body
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // high z-index
                        }}
                      />
                      {selectedLanguage?.value === "Other" && (
                        <input
                          type="text"
                          value={otherLang}
                          placeholder="Other Language"
                          onChange={(e) => setOtherLang(e.target.value)}
                          className="w-full border border-gray-300 rounded-lg p-2 mt-2 focus:outline-none focus:ring-2 focus:ring-blue-100"
                        />
                      )}
                    </div>

                    {/* Current Company Section */}
                    <div className="text-start mb-4">
                      <label className="text-sm font-semibold text-gray-700">
                        Current Company <span className="text-red-500">*</span>
                      </label>
                      <Select
                        options={companyOptions}
                        filterOption={companyFilterOption}
                        isSearchable
                        value={selectedCompany}
                        isClearable
                        onChange={(selectedOption) =>
                          setSelectedCompany(selectedOption)
                        }
                        className="w-full"
                        menuPortalTarget={document.body} // portal to body
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // high z-index
                        }}
                      />
                      {selectedCompany?.value === "Other" && (
                        <input
                          type="text"
                          value={otherCompany}
                          placeholder="Other Company"
                          onChange={(e) => setOtherCompany(e.target.value)}
                          className="w-full border border-gray-300 rounded-lg p-2 mt-2 focus:outline-none focus:ring-2 focus:ring-blue-100"
                        />
                      )}
                    </div>

                    {/* Designation Section */}
                    <div className="text-start mb-4">
                      <label className="text-sm font-semibold text-gray-700">
                        Designation <span className="text-red-500">*</span>
                      </label>
                      <Select
                        options={designationOptions}
                        isSearchable
                        value={selectedDesignation}
                        isClearable
                        onChange={(selectedOption) =>
                          setSelectedDesignation(selectedOption)
                        }
                        className="w-full"
                        menuPortalTarget={document.body} // portal to body
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // high z-index
                        }}
                      />
                      {selectedDesignation?.value === "Other" && (
                        <input
                          type="text"
                          value={otherDesignation}
                          placeholder="Other Designation"
                          onChange={(e) => setOtherDesignation(e.target.value)}
                          className="w-full border border-gray-300 rounded-lg p-2 mt-2 focus:outline-none focus:ring-2 focus:ring-blue-100"
                        />
                      )}
                    </div>

                    {/* Skills Section */}
                    <div className="text-start mb-4">
                      <label className="text-sm font-semibold text-gray-700">
                        Skills <span className="text-red-500">*</span>
                      </label>
                      <CreatableSelect
                        options={skillsOptions}
                        isSearchable
                        value={selectedSkills}
                        isMulti
                        onChange={(selectedOption) =>
                          setSelectedSkills(selectedOption)
                        }
                        className="w-full"
                        menuPortalTarget={document.body} // portal to body
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // high z-index
                        }}
                        formatCreateLabel={(inputValue) => `Add "${inputValue}"`} // <-- Customize label here
                      />
                    </div>

                    {/* Experience Section */}
                    <div className="text-start mb-4">
                      <label className="text-sm font-semibold text-gray-700">
                        Experience (years){" "}
                        <span className="text-red-500">*</span>
                      </label>
                      <Select
                        options={experienceOptions}
                        placeholder="Select Experience"
                        value={selectedExperience}
                        isClearable
                        isSearchable
                        onChange={setSelectedExperience}
                        className="w-full"
                        menuPortalTarget={document.body} // portal to body
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // high z-index
                        }}
                      />
                    </div>

                    {/* Education Section */}
                    <h3 className="text-start text-lg font-semibold mt-8 mb-4">
                      Education
                    </h3>
                    <div className="text-start mb-4">
                      <label className="text-sm font-semibold text-gray-700 flex justify-between">
                        <span>
                          College/University{" "}
                          <span className="text-red-500">*</span>
                        </span>
                        <span>{college ? college.length : 0}/100</span>
                      </label>
                      <input
                        type="text"
                        value={college}
                        onChange={handleCollegeChange}
                        className="w-full border border-gray-300 rounded-lg p-2 mt-1 focus:ring-2 focus:ring-blue-500"
                      />
                    </div>

                    <div className="text-start mb-4">
                      <label className="text-sm font-semibold text-gray-700">
                        Degree <span className="text-red-500">*</span>
                      </label>
                      <Select
                        options={degreeOptions}
                        isSearchable
                        value={selectedDegree}
                        isClearable
                        onChange={(selectedOption) =>
                          setSelectedDegree(selectedOption)
                        }
                        className="w-full"
                        menuPortalTarget={document.body} // portal to body
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // high z-index
                        }}
                      />
                    </div>

                    <div className="text-start mb-4 ">
                      <label className="text-sm font-semibold text-gray-700 ">
                        Passing Year <span className="text-red-500">*</span>
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          value={passingYear}
                          onChange={(date) => setPassingYear(date)}
                          format="MMMM YYYY"
                          views={["year", "month"]}
                          className="w-full"
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                )}
              </main>
            </div>

            <div className="w-full h-[1px] bg-gray-300"></div>

            {/* Footer */}
            <div className="flex justify-end gap-4 mt-2">
              <a
                className="bg-gray-300 text-gray-800 py-2 px-4 rounded-lg cursor-pointer hover:bg-gray-400"
                onClick={closePopup}
              >
                Close
              </a>
              <a
                className="bg-blue-600 text-white py-2 px-4 rounded-lg cursor-pointer hover:bg-blue-700"
                onClick={handleSubmit}
              >
                Save
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Profile;

function convertToBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}
